// Centralized route configuration and helpers
// Simple, flat paths for now; can be extended with loaders/nested routes later.

import { profile } from "console";
import { sign } from "crypto";

export const ROUTES = {
  // Simple pages (single-screen)
  signIn: '/signIn',
  resetPassword: '/reset-password',
  dashboard: '/dashboard',
  turfAiStudio: '/turf-ai-studio',
  activityLogs: '/activity-logs',
  backupHistory: '/backup-history',
  userManagement: '/user-management',
  settings: '/settings',
  profile: '/profile',

  // Chart review + audits
  chartReviewList: '/chart-review',
  chartReviewRun: '/chart-review/run-details',
  chartReviewLog: (runId: string = ':runId') => `/chart-review/logs/${runId}`,
  snChartReview: '/chart-review/chart-details',
  auditDetail: '/audits/details',

  // Chart extraction
  chartExtractionList: '/chart-extractions',
  chartExtractionDetail: '/chart-extractions/run-details',
  // Client overview
  clientOverviewList: '/client-overview',
  clientOverview: (id: string = ':clientId') => `/clients/${id}`,

  // Prompts
  promptsList: '/prompts',
  promptCreate: '/prompts/new',
  promptDetail: '/prompts/details',

  // KanTime
  kanTimeStatus: '/kantime',
  kanTimeLog: '/kantime/logs',
  kanTimeUpdate: (runId: string = ':runId') => `/kantime/update/${runId}`,

  // Magic Links
  magic: '/magic',

  // Renewal Tasks
  renewalTasks: '/renewal-tasks',
  renewalTaskDetail: '/renewal-tasks/:taskId',
  supervisorDashboard: '/supervisor-dashboard',
  supervisorRiskView: '/supervisor-risk-view',
  staffTasksView: (staffId: string = ':staffId') => `/staff/${staffId}/tasks`,
  clientDetailsView: (clientId: string = ':clientId') => `/clients/${clientId}/details`,
  workflowRunLogs: '/workflow-run-logs',
} as const;

// Export view list for helpers
export const VIEW_LIST = {
  renewalTasks: 'renewal-tasks',
  supervisorDashboard: 'supervisor-dashboard',
  supervisorRiskView: 'supervisor-risk-view',
} as const;

// Mapping between existing AppView identifiers and route paths
// This helps us keep AppContext in sync with URL-based navigation.
export const VIEW_TO_PATH: Record<string, string> = {
  signIn: ROUTES.signIn,
  resetPassword: ROUTES.resetPassword,
  dashboard: ROUTES.dashboard,
  'turf-ai-studio': ROUTES.turfAiStudio,
  'audit-logs': ROUTES.activityLogs,
  'backUp-management': ROUTES.backupHistory,
  'user-management': ROUTES.userManagement,
  settings: ROUTES.settings,

  'chat-harvest': ROUTES.chartReviewList,
  'harvest-run-detail': ROUTES.chartReviewRun,
  'audit-goals-detail': ROUTES.auditDetail,
  'sn-chart-detail': ROUTES.snChartReview,

  'chart-extraction-runs': ROUTES.chartExtractionList,
  'chart-extraction-run-detail': ROUTES.chartExtractionDetail,

  'client-clinician-view': ROUTES.clientOverviewList,

  'ai-prompt-manager': ROUTES.promptsList,
  'prompt-detail': ROUTES.promptCreate,

  'kanTime-details': ROUTES.kanTimeStatus,
  'kanTime-runLog': ROUTES.kanTimeLog,
  'kan-time-update': ROUTES.kanTimeUpdate(':runId'),
  profile: ROUTES.profile,

  // Renewal Tasks
  'renewal-tasks': ROUTES.renewalTasks,
  'supervisor-dashboard': ROUTES.supervisorDashboard,
  'supervisor-risk-view': ROUTES.supervisorRiskView,
  'staff-tasks-view': ROUTES.staffTasksView(':staffId'),
  'client-details-view': ROUTES.clientDetailsView(':clientId'),
  'batch-run-log-view': ROUTES.chartReviewLog(':runId'),
  'workflow-run-logs': ROUTES.workflowRunLogs,
};

export const PATH_TO_VIEW: Record<string, string> = Object.fromEntries(
  Object.entries(VIEW_TO_PATH).map(([view, path]) => [path, view]),
);


